import { Chain, base, baseSepolia } from 'viem/chains';
import { getAccount, switchChain } from 'wagmi/actions';
import { config } from '../constants/WagmiConfig';
import { enqueueSnackbar } from 'notistack';

export const activeChain =
  process.env.REACT_APP_ENVIRONMENT === 'development' ? baseSepolia : base;

// Prompts switch network if user is connected to different network
export const checkNetwork = async (chain?: Chain) => {
  const account = getAccount(config);

  let targetChain = chain ? chain : activeChain;

  if (targetChain.id !== account.chainId) {
    await switchChain(config, {
      // @ts-ignore
      chainId: targetChain.id,
    }).catch((err) => {
      console.error(err);

      let errMsg = `Please switch your chain to ${targetChain.name}`;

      enqueueSnackbar({ message: errMsg, variant: 'error' });

      throw new Error(errMsg);
    });
  }
};
